import { ThemeManager } from "../theme-manager/theme-manager";

export const setBackgroundColor = (status?: string) => {
  const theme = ThemeManager.getTheme();
  switch (status) {
    case "success":
      return theme.success;
    case "Error":
    case "error":
      return "#f5e0df";
    default:
      return theme.informationTextBackgroundColor;
  }
};

export const setBackgroundColorIcon = (status?: string) => {
  const theme = ThemeManager.getTheme();
  switch (status) {
    case "Error":
    case "error":
      return "#f5e0df";
    case "waiting":
      return "#e7601c";
    case "flash-on-icon":
    case "payment-icon":
      return theme.disabledColor;
    default:
      return "#FFFFFF";
  }
};

export const setTextColor = (status?: string) => {
  const theme = ThemeManager.getTheme();
  switch (status) {
    case "Error":
    case "error":
      return "#e74c3c";
    case "warning":
      return "#f57c00";
    case "flash-on-icon":
    case "success":
    case "payment-icon":
      return "#FFFFFF";
    case "waiting":
      return "#0e1318";
    default:
      return theme.textColorGray;
  }
};

export const setTextColorIcon = (status?: string) => {
  const theme = ThemeManager.getTheme();
  switch (status) {
    case "success":
      return theme.success;
    case "Error":
    case "error":
      return "#e74c3c";
    case "message":
    case "warning":
      return "#f57c00";
    case "waiting":
    case "flash-on-icon":
    case "payment-icon":
      return "#FFFFFF";
    case "info":
      return "#F0BC0F";
    default:
      return theme.textColorGray;
  }
};
